export default __webpack_public_path__ + "static/general-logo-d928eb1875ac7628c6afe08865d3fc90.png";